// types
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PendingActionFromAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
import { logsEnviroment } from 'config';
import { LoggerType } from 'types/logger';
import axios from 'utils/axios';

// initial state
const initialState: LoggerType = {
    isLoading: true,
    logs: []
};

// ==============================|| SLICE - MENU ||============================== //

const logger = createSlice({
    name: 'logger',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getLogsService.fulfilled, (state, action) => {
                console.log('getLogsService fulfilled');
                state.isLoading = false;
                state.logs = action.payload;
            })
            .addCase(getLogsService.rejected, (state, action) => {
                console.log('getLogsService rejected');
            });
        builder.addMatcher<PendingActionFromAsyncThunk<any>>(
            (action) => /^logger\/[^/]+\/pending$/.test(action.type),
            (state, action) => {
                console.log('getLogsService PENDING');
                state.isLoading = true;
            }
        );
    }
});

export default logger.reducer;

type loggerSearchParams = {
    log: string;
    term?: string;
    startTime: string;
    endTime: string;
};

export const getLogsService = createAsyncThunk(`${logger.name}/getLogs`, async (params: loggerSearchParams) => {
    const slugData = [params.log];

    if (params.term) {
        slugData.push(params.term);
    }

    const response = await axios.get(`${process.env.REACT_APP_SERVICES_URL}/insights/${logsEnviroment[params.log]}`, {
        params: {
            startTime: params.startTime,
            endTime: params.endTime,
            slug: slugData.join(',')
        }
    });

    return response.data;
});
